import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { bindActionCreators } from 'redux';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';
import plusSgn from '@assets/images/plusSgn.svg';
import { urlSearchParams } from '@utility/utills';
import { safeJsonParse } from '@utility/helperFunction';
import { ReactComponent as ModifierNoteLogo } from '@assets/images/modifierNote.svg';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import { ReactComponent as Delete } from '@assets/images/delete.svg';
import { ReactComponent as Minus } from '@assets/images/minus.svg';
import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import ModalPopup from '@components/common/Modal';
import styles from './OrderItemFooter.module.scss';
import { APP_CONFIG } from '@constants';
import {
  toggleNestedModifierFlag,
  pushModifierToItem,
  setNestedModifierArray,
  editModifiers,
  setFunctionModifierId,
  setPosition,
  setCartUpdateLoading,
} from '@reducers/orders';
import {
  handleOnAddCart,
  onNestedBack,
  removeNestedModifier,
  onRemoveItemFromCart,
} from '../OrderItemDetailHandler';
import {
  onGlobalModSave,
  onGlobalModRemove,
} from '../GlobalModifier/GlobalModifierActionHandler';
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import SpecialInstruction from '@containers/OrderItemDetail/SpecialInstructionRevamp';
import Loader from '@components/common/Loader/newLoaderModal';
import store from '@store';
import { setErrorPopUp } from '@reducers/notification';

const OrderItemFooter = ({
  serverAppTheme,
  menuCard,
  menuItemsHashTable,
  isNestedModifier,
  globalSelectedModifierId,
  activeMenuItemId,
  cart,
  seat,
  note = '',
  onNoteChange,
  onResetModGroupFilter,
  toggleNestedModifierFlag,
  pushModifierToItem,
  setNestedModifierArray,
  editModifiers,
  setFunctionModifierId,
  isErrorPopUpOpen,
  isNotificationOpen,
  cartUpdateLoading,
  setErrorPopUp,
}) => {
  const params = useParams();
  const { menuItemId, menuTypeId, internalId } = params;
  const itemInfo = menuCard[menuTypeId][menuItemId];
  const outOfStock = itemInfo.menuItem.outOfStock;
  const navigate = useNavigate();

  const parentMenuItemInfo = useMemo(() => {
    const pid = urlSearchParams('parentMenuItemId');
    return pid ? menuCard[menuTypeId][Number(pid)] : null;
  }, [menuTypeId]);

  const itemDetailsInfo = parentMenuItemInfo || itemInfo;
  const ItemDetails = itemDetailsInfo?.menuItem;
  const minQuantity = ItemDetails?.minOrderQuantity;
  const maxQuantity = ItemDetails?.maxOrderQuantity;

  const computeQuantity = useCallback(() => {
    if (internalId) {
      const cartItem = (cart || []).find(
        c => c.internalId === Number(internalId)
      );
      if (cartItem?.quantity) return cartItem.quantity;
    }
    return minQuantity || 1;
  }, [menuItemId, internalId, minQuantity]); // eslint-disable-line react-hooks/exhaustive-deps

  const showQty = menuItemsHashTable?.[menuItemId]?.cardType === 0 || (menuItemsHashTable?.[menuItemId]?.minOrderQuantity > 0 || menuItemsHashTable?.[menuItemId]?.cardType === 1);

  const [cartQuantity, addCart] = useState(computeQuantity);

  useEffect(() => {
    addCart(computeQuantity());
  }, [computeQuantity]);
  const [openModal, setOpenModal] = useState(false);
  const [isRemoveCartModelOpen, setRemoveCartModel] = useState(false);
  const [browserOrtablet, setBrowserOrtablet] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [pendingAction, setPendingAction] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (isErrorPopUpOpen || isNotificationOpen) {
      setPendingAction(null);
      setLoading(false);
      return;
    }
    if (pendingAction) {
      pendingAction();
      setPendingAction(null);
      setLoading(false);
    }
  }, [pendingAction, isErrorPopUpOpen, isNotificationOpen]);

  const type = useMemo(() => {
    const query = new URLSearchParams(location.search);
    return query.get('type');
  }, []);

  const handleClick = () => {
    if (cartQuantity !== 1) {
      addCart(cartQuantity - 1);
    } else if (internalId) {
      setRemoveCartModel(true);
    }
  };

  const handleClickAdd = () => {
    addCart(cartQuantity + 1);
  };

  const handleRemoveItem = () => {
    onRemoveItemFromCart(internalId, navigate);
  };

  const disableMenuItemMemosValue = useMemo(() => {
    const deviceInfo = safeJsonParse(window.sessionStorage.getItem('deviceInfo'));
    return deviceInfo?.deviceGroup?.serverAppSettings?.disableMenuItemMemos !== true;
  }, []);

  const handleGlobalModDone = useCallback(() => {
    onGlobalModSave(activeMenuItemId);
  }, [activeMenuItemId]);

  const handleGlobalModRemove = useCallback(() => {
    onGlobalModRemove();
  }, []);

  const handleNoteSubmit = (data) => {
    setOpenModal(false);
    if (onNoteChange) onNoteChange(data);
  };

  const handleCancel = useCallback(
    e => {
      e.preventDefault();
      // store.dispatch(setCartUpdateLoading('Loading...'));
      const seat = safeJsonParse(window.sessionStorage.getItem('seat'), {});
      // const position =
      //   seat?.seats?.filter(e => e.open).length > 0
      //     ? seat?.seats?.find(e => e.open)
      //     : { number: -1, position: -1 };
      // store.dispatch(setPosition(position));
      setPendingAction(() => () => {
        if (isNestedModifier) {
          toggleNestedModifierFlag(false);
        }
        window.sessionStorage.removeItem('serverAppModifierGroupDisplayStyle');
        window.sessionStorage.removeItem('pendingItemNote');
        window.sessionStorage.removeItem('pendingModifierNote');
        setNestedModifierArray([]);
        pushModifierToItem([], 'isNested');
        editModifiers({ modifier: '', modifierGroupId: '', modifierName: '' });
        setFunctionModifierId(null);
        navigate(`${APP_CONFIG.BASE_URL}/orders`);
      });
    },
    [
      isNestedModifier,
      toggleNestedModifierFlag,
      setNestedModifierArray,
      pushModifierToItem,
      editModifiers,
      setFunctionModifierId,
      navigate,
    ]
  );

  const handleAddToCart = () => {
    const pendingHoldTime = safeJsonParse(window.sessionStorage.getItem('pendingHoldTime'));
    if ((itemInfo?.menuItem?.cardType === 1 || itemInfo?.menuItem?.cardType === 2) && pendingHoldTime > 0) {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().ITEM_NOT_HELD,
        noErrorTxt: true,
      });
    }
    else {
      handleOnAddCart(params, navigate, cartQuantity, note);
    }
  };
  
  return (
    <>
      {(isNestedModifier || globalSelectedModifierId) ? (
        <div
          className={cn('align-items-center col-12 d-flex p-0')}
          style={{
            background: serverAppTheme?.background_color,
            width: '99.6%',
          }}
        >
          <div className={cn('col-12 px-0 d-flex w-100 justify-content-between align-items-center')}>
            <div
              className={cn(
                'col-12 px-0 d-flex w-100 justify-content-between align-items-end'
              )}
            >
              <div className="col-6 pl-0 pr-1">
                <TouchableButton
                  className={cn('rounded w-100 btn50')}
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    setLoadingMessage('Loading...');
                    setLoading(true);
                    setPendingAction(() => () => {
                      if (isNestedModifier) {
                        removeNestedModifier(menuItemId);
                      } else {
                        handleGlobalModRemove();
                      }
                      onResetModGroupFilter?.();
                    });
                  }}
                  style={{
                    backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                    color: serverAppTheme?.cancleBtn_font,
                    border: serverAppTheme?.cancleBtn_Border,
                    height: '2.75rem',
                  }}
                  rippleEffect={true}
                >
                  <div className="fs_24 fw-600">{LABEL().REMOVE_MOD}</div>
                </TouchableButton>
              </div>
              <div className="col-6 pr-0 pl-1">
                <TouchableButton
                  className={cn('btn-ripple rounded w-100 px-4 border-0 btn50')}
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    // setLoadingMessage('Please wait while we are updating your cart with your changes.');
                    // setLoading(true);
                    setPendingAction(() => () => {
                      if (isNestedModifier) {
                        onNestedBack({ menuItemId, isSave: true });
                      } else {
                        handleGlobalModDone();
                      }
                      onResetModGroupFilter?.();
                    });
                  }}
                  style={{
                    backgroundColor: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                    height: '2.75rem',
                  }}
                  rippleEffect={true}
                >
                  <div className="fs_24 fw-600">{LABEL().DONE_MOD}</div>
                </TouchableButton>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex col-12 px-0">
          {showQty && (
          <div
            className="col-3 p-1 mr-1 d-flex justify-content-between align-items-center"
            style={{
              backgroundColor: 'rgb(229, 229, 229)',
              color: serverAppTheme?.primary_text,
            }}
          >
            <div className={cn('px-0 d-flex ')}>
              <TouchableButton
                className={cn(
                  'border-0 br-4 d-flex justify-content-center align-items-center pl-0',
                  styles.modifierCounterBtn
                )}
                type="button"
                onClick={e => {
                  e.preventDefault();
                  handleClick();
                }}
                disabled={outOfStock || cartQuantity === minQuantity}
                aria-label="minusCartQtyBtn"
                style={{
                  backgroundColor:
                    cartQuantity === 1
                      ? serverAppTheme?.primary_btn_disable
                      : outOfStock || cartQuantity === minQuantity
                      ? serverAppTheme?.primary_btn_disable
                      : serverAppTheme?.primaryBtn,
                      paddingRight: '1px'
                }}
                rippleEffect={true}
              >
                {cartQuantity === minQuantity || cartQuantity === 1 ? (
                  <Delete
                    width={24}
                    height={24}
                    fill={serverAppTheme?.card_bg}
                    opacity={1}
                  />
                ) : (
                  <Minus
                    width={18}
                    height={18}
                    fill={serverAppTheme?.card_bg}
                    opacity={1}
                  />
                )}
              </TouchableButton>
            </div>
            <div className="fw-400 fs_22">{cartQuantity}</div>
            <div className="px-0">
              <TouchableButton
                className={cn(
                  'border-0 rounded px-0',
                  styles.modifierCounterBtn
                )}
                type="button"
                onClick={e => {
                  e.preventDefault();
                  handleClickAdd();
                }}
                disabled={
                  outOfStock || cartQuantity === maxQuantity ? 'true' : ''
                }
                aria-label="plusCartQtyBtn"
                style={{
                  backgroundColor:
                    outOfStock || cartQuantity === maxQuantity
                      ? serverAppTheme?.primary_btn_disable
                      : serverAppTheme?.primaryBtn,
                  opacity: outOfStock || (cartQuantity === maxQuantity && '1'),
                }}
                rippleEffect={true}
              >
                <img
                  src={plusSgn}
                  alt="plusSign"
                  style={{
                    opacity: cartQuantity === maxQuantity && '1',
                    margin: 'auto',
                  }}
                />
              </TouchableButton>
            </div>
          </div>
        )}

        {disableMenuItemMemosValue && (
          <div className={cn('col-1 px-1')}>
            <TouchableDiv
              onClick={e => {
                e.preventDefault();
                setOpenModal(true);
              }}
              className="h-100 w-100 d-flex rounded justify-content-center align-items-center"
              role="presentation"
              style={{
                background: serverAppTheme?.primaryBtn,
              }}
              rippleEffect={true}
              >
                <ModifierNoteLogo fill={serverAppTheme?.seat_box_text} height={32} width={32}/>
              </TouchableDiv>
            </div>
          )}
          {/* Cancel button */}
          <div className={cn('col-3 h-100 px-1')}>
            <TouchableButton
              className={cn(
                'btn44 px-2 col-12 d-flex align-items-center justify-content-center',
                styles.cancelBtn
              )}
              role="presentation"
              onClick={handleCancel}
              rippleEffect={true}
              style={{
                backgroundColor: serverAppTheme?.cancleBtn_bg,
                color: serverAppTheme?.cancleBtn_font,
                border: serverAppTheme?.cancleBtn_Border,
              }}
            >
              <div className="fs_20 fw-600">{LABEL().ORDER_DETAILS_CANCEL}</div>
            </TouchableButton>
          </div>
          <div
            className={cn(showQty ? 'col-5' : 'col-8', 'px-1')}
            // style={{
            //   flexBasis: showQty ? '39.66%' : '',
            // }}
          >
            <TouchableButton
              type="button"
              className={cn('btn44 shadow-none w-100 h-100 px-2')}
              onClick={e => {
                e.preventDefault();
                // window.sessionStorage.removeItem('pendingItemNote');
                handleAddToCart();
              }}
              disabled={
                outOfStock || urlSearchParams('parentMenuItemId') === menuItemId
              }
              style={{
                background:
                  outOfStock ||
                  urlSearchParams('parentMenuItemId') === menuItemId
                    ? serverAppTheme?.secondaryBtnDisabled
                    : serverAppTheme?.secondaryBtn,
                color:
                  outOfStock ||
                  urlSearchParams('parentMenuItemId') === menuItemId
                    ? serverAppTheme?.btn_font_color_disabled
                    : serverAppTheme?.btn_font_color,
              }}
              rippleEffect={true}
            >
              <div className="fs_20 fw-600">{`${
                internalId && type === 'edit'
                  ? LABEL().UPDATE_CART
                  : LABEL().ADD_TO_CART
              }`}</div>
            </TouchableButton>
          </div>
        </div>
      )}
      {openModal && (
        <FullWidthModal
          isOpen={openModal}
          loading={false}
          customClass2="w-100 h-100"
          noBackground
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            pointerEvents: 'auto',
            backgroundColor: serverAppTheme?.popUp_bg,
            backgroundClip: 'padding-box',
            height: '33rem',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            color: serverAppTheme?.primary_text,
          }}
        >
          <div
            className="col-12 px-0 m-auto justify-content-center align-items-center position-relative text-center"
            style={{ color: serverAppTheme?.primary_text }}
          >
            <SpecialInstruction
              name="specialInstruction"
              type="text"
              isOpen={openModal}
              specialValue={note}
              customClass=""
              specialInstruction
              className="p-2 w-100"
              placeholder="Add a Note"
              maxLength={20}
              onSubmit={data => handleNoteSubmit(data)}
              setBrowserOrtablet={setBrowserOrtablet}
              browserOrtablet={browserOrtablet}
              serverAppTheme={serverAppTheme}
              setOpenModal={setOpenModal}
              seat={seat}
              Item={true}
            />
          </div>
        </FullWidthModal>
      )}
      {isRemoveCartModelOpen && (
        <ModalPopup
          isOpen={isRemoveCartModelOpen}
          isModalCenter
          style={{
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: '75%',
            margin: 'auto',
            minHeight: '42%',
            height: 'auto',
            padding: '1.5rem',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
          }}
          noBackground
          customClass="h-100 w-100"
          customClass2="h-100 w-100 p-3"
        >
          <div
            style={{ flex: 1, color: serverAppTheme?.primary_text }}
            className="justify-content-center align-items-center text-center h-100 position-relative"
          >
            <div className="col-12 fs_18 fw-700 text-center h-auto">
              Are You Sure ?
            </div>
            <br />
            <div className="col-12 px-0 fs_15 fw-400 text-center h-auto">
              {CUSTOM_MESSAGES().DELETE_ITEM_CONFIRMATION}
            </div>
            <div
              style={{ bottom: '0', left: '0' }}
              className="col-12 px-0 h-30 d-flex justify-content-center align-items-center text-center position-absolute"
            >
              <div className="col-6 pl-0 pr-1">
                <button
                  style={{
                    background: serverAppTheme?.OFF_Premise_Btn,
                    color: serverAppTheme?.cancleBtn_font,
                    border: serverAppTheme?.cancleBtn_Border,
                  }}
                  className={cn('col-12 fs_24 fw-600 btn-44 rounded btn44')}
                  type="button"
                  onClick={() => {
                    setRemoveCartModel(false);
                  }}
                >
                  {LABEL().NO}
                </button>
              </div>
              <div className="col-6 pl-1 pr-0">
                <button
                  style={{
                    background: serverAppTheme?.secondaryBtn,
                    color: serverAppTheme?.btn_font_color,
                  }}
                  className={cn(
                    'col-12 btn-ripple fs_24 fw-600 border-0 rounded btn44'
                  )}
                  type="button"
                  onClick={() => {
                    setRemoveCartModel(false);
                    handleRemoveItem();
                  }}
                >
                  {LABEL().YES}
                </button>
              </div>
            </div>
          </div>
        </ModalPopup>
      )}
      {loading && <Loader message={loadingMessage} />}
    </>
  );
};

const mapStateToProps = ({ orders, theme, notification }) => ({
  activeMenuItemId: Number(urlSearchParams('menuId')) || 0,
  menuCard: orders.menuCardList,
  menusList: orders.menusList,
  menuIndex: orders.menuIndex,
  menuItemsHashTable: orders.menuItemsHashTable,
  cart: orders.cart,
  seat: orders.seats,
  serverAppTheme: theme.serverAppTheme,
  isNestedModifier: orders.isNestedModifier,
  globalSelectedModifierId: orders.globalSelectedModifierId,
  isErrorPopUpOpen: notification.isErrorPopUpOpen,
  isNotificationOpen: notification.isOpen,
  cartUpdateLoading: orders.cartUpdateLoading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleNestedModifierFlag,
  pushModifierToItem,
  setNestedModifierArray,
  editModifiers,
  setFunctionModifierId,
  setErrorPopUp,
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(OrderItemFooter));
